import { render, staticRenderFns } from "./TextareaWithAutoTexts.vue?vue&type=template&id=229cf58f&"
import script from "./TextareaWithAutoTexts.vue?vue&type=script&lang=js&"
export * from "./TextareaWithAutoTexts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports